export default __webpack_public_path__ + "static/media/completeSignup_topik.3eddc695.png";